import Component from '../colorz/Component';
import device from '../colorz/utils/device';
import Flickity from 'flickity-imagesloaded';

module.exports = class FpliveTabs extends Component {
    onInit( el, args) {
        // Initializations
        this.el = el;
        this.tabs = this.el.querySelectorAll('.js-tab');
        this.active = 0;
    }

    onReady() {
        if ( window.matchMedia("(max-width: 600px)").matches ) {
            this.initSlider();
            var scrollbyValue = 200;
        }

        var scrollbyValue = 100;
        
        for (var i = 0; i < this.tabs.length; i++){
            var urlString = window.location.href;
            if ( this.tabs[i].firstElementChild.href == urlString ) {
                this.tabs[i].classList.add('active');
                // scroll to categroy filter
                if ( window.location.search.indexOf('?') > -1 ) {
                    this.el.scrollIntoView(true);
                    window.scrollBy(0, -scrollbyValue);
                }
  
            } else {
                this.tabs[i].classList.remove('active');
            }
        }
    }

    initSlider(){
        var options = {
            cellSelector: '.js-tab',
            pageDots: false,
            cellAlign : 'left',
            prevNextButtons: false,
            wrapAround: false,
            imagesLoaded: true,
            draggable: true
        };

        // init slider
        this.slider = new Flickity(this.el, options);

    }
};